import { useState } from "react";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

type UsePortalSessionOptions = {
    returnUrl?: string;
    isPaymentFeatureEnabled?: boolean;
};

export const usePortalSession = (options?: UsePortalSessionOptions) => {
    const { selectedCompany } = useFoodpilotContext();
    const companyId = selectedCompany?.id;
    const isPaymentFeatureEnabled = options?.isPaymentFeatureEnabled ?? false;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const openPortal = async () => {
        if (!isPaymentFeatureEnabled) {
            setError(null);
            return;
        }

        if (!companyId) {
            setError("No company selected");
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const baseUrl = `/api/organizations/${companyId}/payment/portal-session`;
            const url = options?.returnUrl ? `${baseUrl}?return_url=${encodeURIComponent(options.returnUrl)}` : baseUrl;

            const response = await loggedInApiCall.get(url);

            if (response.data?.portalUrl) {
                window.location.href = response.data.portalUrl;
            } else {
                throw new Error("No portal URL received");
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "Failed to open billing portal";
            setError(errorMessage);
            console.error("Error opening portal:", err);
        } finally {
            setLoading(false);
        }
    };

    return { openPortal, loading, error };
};
